import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { IconId } from '@src/main/ui/components/common/Icon/IconId';
import { useUserThemeContext } from '@src/main/ui/providers/user/UserThemeContextProvider';
import { FC, MouseEventHandler } from 'react';
import styles from './DrawerItemButton.module.scss';

interface DrawerItemButtonProps {
  icon?: IconId;
  text: string;
  onClick: MouseEventHandler<HTMLAnchorElement>;
  onMouseEnter: MouseEventHandler<HTMLAnchorElement>;
  isActive: () => boolean;
}

const defaultProps = { icon: undefined };

const DrawerItemButton: FC<DrawerItemButtonProps> = ({
  icon,
  text,
  onClick,
  onMouseEnter,
  isActive,
}) => {
  const { theme } = useUserThemeContext();
  return (
    <ListItem key={text} disablePadding>
      <ListItemButton
        sx={{
          paddingTop: 1,
          paddingBottom: 0,
          transition: '0.1s',
          ...(theme === 'Corporate' && {
            '&:hover': {
              color: 'black',
              backgroundColor: 'white',
            },
            '&.Mui-selected': {
              color: 'black',
              backgroundColor: 'white',
            },
            '&.MuiListItemButton-root.Mui-selected:hover': {
              color: 'black',
              backgroundColor: 'white',
            },
          }),
        }}
        component="a"
        selected={isActive()}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
      >
        <div className={styles.drawerItem__button}>
          {icon ? <Icon iconId={icon} /> : undefined}
          <ListItemText
            primary={text}
            primaryTypographyProps={{
              variant: 'body2',
            }}
            sx={{ textAlign: 'center' }}
          />
        </div>
      </ListItemButton>
    </ListItem>
  );
};

DrawerItemButton.defaultProps = defaultProps;

export default DrawerItemButton;
